import { createSlice } from "@reduxjs/toolkit";
import OrganisationSetting from "../pages/ConfigPages/OrganisationSetting";
 
export const logindata = createSlice({
    name: 'logindata',
 
    initialState: {
        username: '',
        userinactivitytimeout: 0,
        userprops: {
            userauthstate: 0,
            userpermissions: 0
        },
        userdetails: {},
        organisationdata: {},
        projectdata: [],
        plantjson: []
    },
 
    reducers: {
        updateusername: (state, username) => {
            state.username = username.payload
        },
 
        updatelogindetails: (state, userprops) => {
            state.userprops = userprops.payload
        },
        updateuserdeatils: (state, userdetails) => {
            state.userdetails = userdetails.payload
        },
        updateorganizationdata: (state, orgdata) => {
            state.organisationdata = orgdata.payload
        },
        updateprojectdata: (state, prodata) => {
            state.projectdata = prodata.payload
        },
        updateplatjson: (state, plantjsondata) => {
            state.plantjson = plantjsondata.payload
   
        },
        clearLoginData: (state) => {
            state.username = ''
            state.userprops = {
                userauthstate: 0,
                userpermissions: 0
            }
            state.userdetails = {};
            state.organisationdata = {};
            state.projectdata = [];
            state.plantjson = [];
        }
        ,updateuserinactivitytimeout: (state, timeout) => {
            state.userinactivitytimeout = timeout.payload
        }    
    }
})
 
export const {updateusername, updatelogindetails, updateuserdeatils, updateorganizationdata, updateprojectdata, updateplatjson, clearLoginData, updateuserinactivitytimeout} = logindata.actions
export default logindata.reducer